import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import { gql, useQuery } from '@apollo/client';
import clientGraphql from '../../../common/apollo-graphql';
import AuthContext from '../../auth/context/AuthContext';

const wrapLabel = (text, maxLineLength = 30) => {
  const words = text.split(' ');
  let lines = [];
  let currentLine = '';

  words.forEach(word => {
    if ((currentLine + word).length <= maxLineLength) {
      currentLine += (currentLine ? ' ' : '') + word;
    } else {
      lines.push(currentLine);
      currentLine = word;
    }
  });

  if (currentLine) lines.push(currentLine);

  return lines.join('\n');
};

const REFERRAL_LIST_BY_USER = gql`
  query ReferralListByUser($startDate: String!, $endDate: String!, $type: String) { 
    referral_list_by_user(start_date: $startDate, end_date: $endDate, type: $type) {
      name
      referrals
    }
  }
`;

export default function ReferralListByUser({ startDate, endDate, type }) {
  const currentUser = useContext(AuthContext);
  
  let color, label;

  switch (type) {
    case 'sent':
      color = '#1abc9c';
      label = 'Sent';
      break;
    case 'accepted':
      color = '#3498db';
      label = 'Accepted';
      break;
    case 'declined':
      color = '#e74c3c';
      label = 'Declined';
      break;
    default:
      color = '#95a5a6'; // fallback gray
      label = '';
  }

  const { loading, data } = useQuery(REFERRAL_LIST_BY_USER, {
    client: clientGraphql,
    variables: {
      type,
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    skip: !currentUser,
  });

  const referrals = (data?.referral_list_by_user || []).map(item => ({
    name: wrapLabel(item.name),
    referrals: item.referrals,
  }));


  const totalReferrals = referrals.reduce((sum, r) => sum + r.referrals, 0);

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        Total Referrals {label} by Users <br />
        {startDate.format('MMMM YYYY')} - {endDate.format('MMMM YYYY')}
      </Typography>

      {referrals.length > 0 ? (
        <BarChart
          dataset={referrals}
          yAxis={[{ scaleType: 'band', dataKey: 'name' }]}
          series={[{ dataKey: 'referrals', label: `Referrals ${label} (${totalReferrals})`, color }]}
          layout="horizontal"
          grid={{ vertical: true }}
          height={Math.max(referrals.length * 40, 500)}
          xAxis={[{ label: 'Number of Referrals', tickMinStep: 1 }]}
          margin={{ left: 200, right: 50, top: 50, bottom: 50 }}
          loading={loading}
        />
      ) : (
        'No data found'
      )}
    </Box>
  );
}
